module.exports = __webpack_public_path__ + "img/square_header_activity.340e4809.png";